export const mutations = {
    SET_ARTICLES: (state, data) => {
        state.articles = data
    }
}